function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationShuttleBusFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.941 20h-2.293a3.494 3.494 0 00-3.148-2 3.498 3.498 0 00-3.15 2h-7.702A3.494 3.494 0 008.5 18a3.498 3.498 0 00-3.15 2H4v-4h23.942v4zm-5.44 3a1.498 1.498 0 01-1.41-1 1.507 1.507 0 01-.09-.5 1.501 1.501 0 013 0c0 .176-.038.343-.093.5a1.5 1.5 0 01-1.408 1zm-14 0a1.498 1.498 0 01-1.41-1 1.507 1.507 0 01-.09-.5 1.501 1.501 0 013 0c0 .176-.038.343-.093.5A1.5 1.5 0 018.5 23zm1.59-14h2.91v3h2V9h4v3h2V9h5.197l1.42 5H6.29l3.802-5zm19.817 5.836c-.006-.036.005-.073-.005-.109l-1.987-7A1 1 0 0026.954 7H9.595c-.312 0-.606.146-.796.395L3.776 14H3a1 1 0 00-1 1v6a1 1 0 001 1h2.05c.245 1.692 1.691 3 3.45 3 1.758 0 3.204-1.308 3.45-3h7.1c.245 1.692 1.691 3 3.45 3 1.758 0 3.204-1.308 3.45-3h2.991a1 1 0 001-1v-6c0-.058-.023-.108-.033-.164z",
    fill: props.color
  }));
}

export default SvgIconTransportationShuttleBusFilled;